var _rect, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3869 -502C-3869 -503.105 -3868.1 -504 -3867 -504H144C145.105 -504 146 -503.105 146 -502V550C146 551.105 145.104 552 144 552H-3867C-3868.1 552 -3869 551.105 -3869 550V-502Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-3867 -503H144V-505H-3867V-503ZM145 -502V550H147V-502H145ZM144 551H-3867V553H144V551ZM-3868 550V-502H-3870V550H-3868ZM-3867 551C-3867.55 551 -3868 550.552 -3868 550H-3870C-3870 551.657 -3868.66 553 -3867 553V551ZM145 550C145 550.552 144.552 551 144 551V553C145.657 553 147 551.657 147 550H145ZM144 -503C144.552 -503 145 -502.552 145 -502H147C147 -503.657 145.657 -505 144 -505V-503ZM-3867 -505C-3868.66 -505 -3870 -503.657 -3870 -502H-3868C-3868 -502.552 -3867.55 -503 -3867 -503V-505Z",
    fill: "black",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_35)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 856,
    transform: "translate(-329 -404)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 784,
    transform: "translate(-329 -332)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0.25C8.07164 0.25 6.18657 0.821828 4.58319 1.89317C2.97982 2.96451 1.73013 4.48726 0.992179 6.26884C0.254225 8.05042 0.061142 10.0108 0.437348 11.9021C0.813554 13.7934 1.74215 15.5307 3.10571 16.8943C4.46928 18.2579 6.20656 19.1865 8.09787 19.5627C9.98919 19.9389 11.9496 19.7458 13.7312 19.0078C15.5127 18.2699 17.0355 17.0202 18.1068 15.4168C19.1782 13.8134 19.75 11.9284 19.75 10C19.747 7.41506 18.7188 4.93684 16.891 3.10901C15.0632 1.28118 12.5849 0.252988 10 0.25ZM14.6436 8.29272L9.14307 13.5427C9.00322 13.6758 8.81756 13.75 8.62452 13.75C8.43147 13.75 8.24582 13.6758 8.10596 13.5427L5.35645 10.9177C5.2128 10.7801 5.12965 10.5911 5.12524 10.3923C5.12084 10.1934 5.19555 10.0009 5.33297 9.8571C5.47038 9.71328 5.65927 9.62989 5.85813 9.62523C6.05699 9.62058 6.24956 9.69504 6.39356 9.83228L8.62452 11.9629L13.6064 7.20728C13.7504 7.07004 13.943 6.99558 14.1419 7.00023C14.3407 7.00489 14.5296 7.08828 14.667 7.2321C14.8045 7.37592 14.8792 7.56841 14.8748 7.76727C14.8704 7.96614 14.7872 8.15513 14.6436 8.29272Z",
    fill: "#45B150"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 856,
    fill: "white",
    transform: "translate(-329 -404)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckin);
export default __webpack_public_path__ + "static/media/ic_checkin.43c9362c.svg";
export { ForwardRef as ReactComponent };